import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { deleteAnneeScolaire, getAnneeScolaire } from './annee-scolaire.reducer';

export const AnneeScolaireDeleteDialog = (props: RouteComponentProps<{ ecoleid: string; id: string }>) => {
  const { ecoleid, id } = props.match.params;
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAnneeScolaire(id));
  }, []);

  const anneeScolaire = useAppSelector(state => state.anneeScolaire.entity);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/annee-scolaire/${ecoleid}`);
  };

  const confirmDelete = () => {
    const entity = {
      id: props.match.params.id,
      ecoleId: props.match.params.ecoleid,
    };
    dispatch(deleteAnneeScolaire(entity));
    handleClose(event);
  };

  return (
    <Modal isOpen toggle={handleClose} centered>
      <ModalHeader toggle={handleClose} data-cy="anneeScolaireDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="korischoolApp.annee-scolaire.delete.question">
        Etes-vous sure de vouloir supprimer l&apos;annee scolaire {anneeScolaire?.nom}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-matiere" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AnneeScolaireDeleteDialog;
